import axios from "../utils/axios";

export function fetchMixpanelDashboards(
  token: any,
  date: {from: string, to: string},
  dashboard: string,
  companyId: string | null = null,
) {
  return new Promise((resolve, reject) => {
    let data: {
      dashboard: string,
      from_date: string,
      to_date: string,
      company?: string
    } = {
      dashboard: dashboard,
      from_date: date.from,
      to_date: date.to
    }
    if (companyId) {
      data.company = companyId
    }
    axios
      .post(
        `${process.env.REACT_APP_API_DOMAIN}/mixpanel-dashboards/`,
        data,
        {
          headers: {
            Authorization: "Token " + token
          },
        }
      )
      .then((response) => {
        if (response.status === 201) {
          resolve(response.data);
        } else {
          alert(`\nMixpanel dashboard: ${dashboard}\nStatus: ${response.status}`)
        }
        reject(response.data);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

